import { PageHeading } from "../../components/common/pageHeading/PageHeading";
import { UpdatePasswordRequest } from "../../components/user/updatePasswordRequest/UpdatePasswordRequestRequest";
import styles from "./updatePassword.module.css";
export const UpdatePassword = () => {
  return (
    <main className={styles.updatePassMain}>
      <PageHeading title={"Reset Password"} />
      <section
        className={`${styles.resetPasswordForm}  animate__animated animate__fadeIn`}
      >
        <UpdatePasswordRequest />
      </section>
    </main>
  );
};
